// function sectionRendering() {

//     // header section 
//     fetch("?section_id=header")
//         .then((res) => res.text())
//         .then((data) => {
//             var cart__html = $(data);
//             var render__html = $(".header__menu", cart__html);
//             $(".header__menu").replaceWith(render__html);
//         });
// }


// match variant and update variant id and variant image 

function selectedVarint() {

    var slectedId = $(".select__variant").val();
    var url = new URL(window.location.href);
    url.searchParams.set("variant", slectedId);
    window.history.replaceState({}, "", url);
}

// update variant image 



const storedOptions = localStorage.getItem("selectedVariantOptions");
if (storedOptions) {
    const options = JSON.parse(storedOptions);
    let matchedVariantId = null;
    $(".select__variant option").each(function () {
        const $opt = $(this);
        if (
            $opt.data("option1") == options.option1 &&
            $opt.data("option2") == options.option2 &&
            $opt.data("option3") == options.option3
        ) {
            matchedVariantId = $opt.val();
            return false; // break loop
        }
    });
    if (matchedVariantId) {
        const url = new URL(window.location.href);
        if (url.searchParams.get("variant") != matchedVariantId) {
            url.searchParams.set("variant", matchedVariantId);
            window.location.href = url.toString();
        }
    }
}


// match variant 
function matchVariant() {
    var updateValue = "";
    $(".main-product__variants input[type='radio']:checked").each(function () {
        updateValue += (updateValue ? " / " : "") + $(this).val();
        // console.log('updateValue',updateValue)
        var title = $('#reservation-product').data('title');
        $('#reservation-product').val(title+' - '+updateValue);
    })

    var foundVariant = false;
    $(".select__variant option").each(function () {
        var optionValue = $(this).text().trim();
        if (updateValue.toLowerCase() == optionValue.toLowerCase()) {

            $(this).prop("selected", true);
            var variant__available = $(this).attr("data-variant-available");
            variantChange($(this).val());
            if(variant__available == 'false'){
                $(".main-product__atc").addClass("product__not-available");
                $(".main-product__atc").text("Sold out");
            }else{
                $(".main-product__atc").removeClass("product__not-available"); 
                $(".main-product__atc").text("Add to cart");
            }
            foundVariant = true;
            return true;
        } 
        
    });
    if(foundVariant == false){
        var opt1 = $('[data-option-position="1"] input:checked').val();
        $(".select__variant option").each(function () {
            var optionValue = $(this).text().trim();
            if (optionValue.toLowerCase().includes(opt1.toLowerCase())) {
                $(this).prop("selected", true);
                foundVariant = true;
                variantChange($(this).val());
                return false; // Break out of the loop
            }

        })
    }

     
}
function imgTextItemAdjustment(){
    if($(window).width() > 1024){
        if($('.img-text-blogs__item').length > 2){
            var contentH = $('.img-text-blogs__item:nth-child(2)').find('.img-text-blogs__content').outerHeight() +40;
            $('.img-text-blogs__item:nth-child(3) .img-text-blogs__content').css('padding-top', contentH+'px');
        }
    } else {
        // Reset padding when window is resized below 1025px
        $('.img-text-blogs__item:nth-child(3) .img-text-blogs__content').css('padding-top', '');
    }
}
$(window).on('load resize', function () {      
  imgTextItemAdjustment();
})
// Get cookie helper function
function getCookie(name) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
    return null;
}

// Check URL parameter and slide down build-hero__inner if sbst=1
function checkSbstParameter() {
    var urlParams = new URLSearchParams(window.location.search);
    var sbst = urlParams.get('sbst');
    if (sbst === '1' && $('.build-hero__inner').length > 0) {
        $('.build-hero__inner').slideDown();
    }
}

// Check secure-slot-terms cookie and update checkbox/button if agreed
function checkSecureSlotTerms() {
    if ($('#terms-checkbox').length > 0 && $('.build-hero__btn-link').length > 0) {
        const secureSlotTerms = getCookie('secure-slot-terms');
        if (secureSlotTerms === 'agreed') {
            $("#terms-checkbox").prop("checked", true);
            $('.build-hero__btn-link').prop('disabled', false);
        }
    }
}

function variantChange(variantId){
    $('body').addClass('pointevents-none');
    $.ajax({
        type: "GET",
        url: "/products/"+window.location.pathname.split("/").pop()+".js",
        dataType: "json",
        success: function (data) {
            var variant = data.variants.filter(function (item) {
                return item.id == variantId;
            });
            if(variant.length > 0){
                // Wait for all fetch promises to complete
                Promise.all([
                    fetch(`?section_id=main-product&variant=${variantId}`)
                        .then((res) => res.text())
                        .then((data) => {
                            var cart__html = $(data);
                            var main = $(".main-product", cart__html);
                            $(".main-product").replaceWith(main);
                            
                            // GET STORED VALUE FROM LOCAL STORAGE AND EDIT PRICING ACCORDINGLY
                            const dropdownSelections = JSON.parse(localStorage.getItem('dropdownSelections')) || {};
                            let totalPrice = $('.select__variant option:selected').data('price-value');
                            if(dropdownSelections.length > 0){
                                dropdownSelections.forEach(element => {
                                    let target = element.target;
                                    let value = element.value;
                                    let targetElement = $('.dropdown-data-target[data-name="'+target+'"]');
                                    targetElement.html(value);

                                    let selectedOption = targetElement.parent().find('.dropdown-item[data-value="'+value+'"]');

                                    if(selectedOption.length > 0){
                                        selectedOption.addClass('active');
                                        if(selectedOption.hasClass('product-add-on-item') && selectedOption.data('add-on-price') != 0){
                                            targetElement.parent().find('input[type="hidden"]').val(selectedOption.data('prod-id'));
                                            totalPrice = parseFloat(totalPrice) + parseFloat(selectedOption.data('add-on-price'));
                                            if (totalPrice % 1 === 0) {
                                                $('.price-target span.money').text('£' + totalPrice.toLocaleString());
                                            } else {
                                                let formattedPrice = totalPrice.toFixed(2);
                                                $('.price-target span.money').text('£' + formattedPrice.toLocaleString());
                                            }    
                                        } else {
                                            targetElement.parent().find('input[type="hidden"]').val(value);
                                        }
                                    }
                                    

                                });
                            }


                            const engravingData = JSON.parse(localStorage.getItem('engravingDetails')) || {};
                            // console.log('engravingData',engravingData);
                            if(engravingData && engravingData.type){
                                if(engravingData.type == 'text'){
                                    $('.custom-engraving-options .dropdown-button').html('Text engraving');
                                    $('#custom-engraving').attr('name','items[0]properties[Text engraving]');
                                    $('#custom-engraving').val(engravingData.details.text);
                                    $('.custom-engraving-font .dropdown-button').html(engravingData.details.font);
                                    $('#engraving-option-font').attr('name','items[0]properties[Font]');
                                    $('#engraving-option-font').val(engravingData.details.font);
                                    if (engravingData.details.text) {
                                        $('.text-engraving-area p').text(engravingData.details.text);
                                    } else {
                                        $('.text-engraving-area p').text('Enter text');
                                    }
                                    let font = $('.engraving-font[data-value="'+engravingData.details.font+'"]').data('class');
                                    $('.text-engraving-area p').removeClass().addClass(font);

                                }else if(engravingData.type == 'map'){
                                    $('.custom-engraving-options .dropdown-button').html('Map engraving');

                                    $('.custom-engraving-map .dropdown-button').html(engravingData.details.mapType);
                                    $('#engraving-option-map').val(engravingData.details.mapType);
                                    $('#engraving-option-map').attr('name','items[0]properties[Map engraving]');
                                    if (engravingData.details.mapType == "Custom location") {
                                        $('.custom-engraving-wrap').show();
                                        $('#custom-map-engraving').val(engravingData.details.link);
                                        $('#custom-map-engraving').attr('name','items[0]properties[_Map link]');
                                    }
                                    var selectedMapOption = $('#dropdown-menu-map .engraving-map[data-value="'+engravingData.details.mapType+'"]'),
                                    img = selectedMapOption.data('img-src'),
                                    imgsrcset = selectedMapOption.data('img-srcset');
                                    $('.main-product__img-wrapper .map-engraving-target img').attr('src',img);
                                    $('.main-product__img-wrapper .map-engraving-target img').attr('srcset',imgsrcset);
                                    
                                }
                            }
                            // const addOnKey = "add-on-{{ addOn.name | handleize }}";
                            // const targetSelection = dropdownSelections.find(selection => selection.target === addOnKey);
                            // const storedValue = targetSelection ? targetSelection.value : null;

                            // if (storedValue) {
                            // }


                        }),
                    fetch(`?section_id=product-model-story-meta&variant=${variantId}`)
                        .then((res) => res.text())
                        .then((data) => {
                            var cart__html = $(data);
                            var story = $(".story-section-wrapper", cart__html);
                            $(".story-section-wrapper").replaceWith(story);
                             imgTextItemAdjustment();
                            // if(story.find('.enamel-hero').length > 0 || story.find('.img').length > 0  || story.find('.img-text-blogs').length > 0){
                            //     $('.main-product__link-story').show();
                            // } else {
                            //     $('.main-product__link-story').hide();
                            // }

                        }),
                    fetch(`?section_id=product-details-meta&variant=${variantId}`)
                        .then((res) => res.text())
                        .then((data) => {
                            var cart__html = $(data);
                            var details = $(".details-wrapper", cart__html);
                            $(".details-wrapper").replaceWith(details);
                            // if(details.find('.details-img').length > 0){
                            //     $('.main-product__link-details').show();
                            // } else {
                            //     $('.main-product__link-details').hide();
                            // }
                        }),
                    fetch(`?section_id=product-specification-meta&variant=${variantId}`)
                        .then((res) => res.text())
                        .then((data) => {
                            var cart__html = $(data);
                            var specs = $(".specifications", cart__html);
                            $(".specifications").replaceWith(specs);
                            // if(specs.find('.specifications__inner').length > 0){
                            //     $('.main-product__link-specifications').show();
                            // } else {
                            //     $('.main-product__link-specifications').hide();
                            // }

                        }),
                    fetch(`?section_id=product-slider-meta&variant=${variantId}`)
                        .then((res) => res.text())
                        .then((data) => {
                            var cart__html = $(data);
                            var slider = $(".text-slider-wrap", cart__html);
                            $(".text-slider-wrap").replaceWith(slider);
                            if(slider.find('.text-slider__inner').length > 0){
                                $('.text-slider__items').slick({
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                    arrows: false,
                                    infinite: true,
                                    responsive: [
                                        {
                                            breakpoint: 768,
                                            settings: {
                                                slidesToShow: 1,
                                                infinite: true,
                                                slidesToScroll: 1
                                            }
                                        },
                                    ]
                                });
                                // $('.main-product__link-wrist').show();
                            } else {
                                $(".text-slider-wrap").replaceWith(slider);
                                // $('.main-product__link-wrist').hide();
                            }
                           
                        })
                ]).then(function() {
                    // All fetches completed, check for sbst parameter
                    checkSbstParameter();
                    // Check secure-slot-terms cookie and update checkbox/button
                    checkSecureSlotTerms();
                });
                if($('.pdp-login-form').length > 0){
                    var fullUrl = window.location.href;
                    $('#checkout_url').val(fullUrl);
                }
            }
            $('body').removeClass('pointevents-none');
        }
    });

}

$("body").on("change",".main-product__variants input[type='radio']",function () {
    selectedVarint();
    matchVariant();
    // Store option1, option2, and option3 values from the selected variant in localStorage
    var selectedOption = $(".select__variant option:selected");
    var variantOptions = {
        option1: selectedOption.data("option1"),
        option2: selectedOption.data("option2"),
        option3: selectedOption.data("option3")
    };
    localStorage.setItem("selectedVariantOptions", JSON.stringify(variantOptions));
})

matchVariant();

// Check sbst parameter after initial variant matching (with delay to ensure async operations complete)
setTimeout(function() {
    checkSbstParameter();
    // Check secure-slot-terms cookie and update checkbox/button
    checkSecureSlotTerms();
}, 500);

$('body').on('click','.build-slot-modal', function () {
    $('.build-hero__inner').slideToggle();
})


$('body').on("click",".overlay", function () {
    $(".quick__view-modal").fadeOut();
    $(this).removeClass("open__modal");
})

// 


$('body').on("click",".main-product__atc", function (e) {
    e.preventDefault();
    const formData = $(this).closest(".product-card__forms").serializeArray();
    const items = [];
    var allRequiredFields = true;
    if($('.main-product__dropdown[data-required="true"]').length > 0){
        $('.main-product__dropdown[data-required="true"]').each(function(){
            if (!$(this).find('input').val()) {
                allRequiredFields = false;
                $(this).find('.required-field-message').slideDown();
            }
        })
    }
    if(allRequiredFields == true){
        $.each(formData, function(index, field) {
        if (field.name.startsWith('items[')) {
            const itemIndex = field.name.match(/items\[(\d+)\]/)[1];
            if (!items[itemIndex]) {
            items[itemIndex] = { quantity: 1, properties: {} }; // Add quantity and properties
            }
            const itemKey = field.name.replace(`items[${itemIndex}]`, '');
            if (itemKey.startsWith('properties')) {
            const propertyKey = itemKey.replace('properties[', '').replace(']', '');
            items[itemIndex].properties[propertyKey] = field.value;
            } else if (itemKey === 'id') {
            items[itemIndex][itemKey] = parseInt(field.value, 10); // Convert id to integer
            } else {
            items[itemIndex][itemKey] = field.value;
            }
        }
        });
        // console.log(JSON.stringify({ items }));
        addToCart(items)
    }
})


function addToCart(items) {
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        contentType: 'application/json',
        data: JSON.stringify({ items }),
        success: function (data) {
            // console.log(data)
            // sectionRendering();
            window.location.href = "/cart";

        },
        error: function (err) {
            console.log(err);
        },
    });
}
function removeFromCart(lineItemId) {
    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: {
            id: lineItemId,
            quantity: 0
        },
        success: function (data) {
            // console.log("Item removed:", data);
            // Optionally, you can refresh the cart or update the UI here
            fetch("?section_id=main-cart-items")
                .then((res) => res.text())
                .then((data) => {
                    var cart__html = $(data);
                    var newCart = $(".cart__wrapper", cart__html);
                    $(".cart__wrapper").replaceWith(newCart);
                });
        },
        error: function (err) {
            console.log("Error removing item:", err);
        }
    });
}
$('.cart__inner').on('click','.remove-item > a', function (e) {
    e.preventDefault();
    var lineItemId = $(this).data('remove-product');
    removeFromCart(lineItemId);
})

$('body').on('change', '.build-hero__select', function () {
    var selected = $(this).val(),
    price = $(this).find(':selected').data('price');
    $('.build-hero__right .build-hero__price .money').text(price);

    $('.build-hero__right input[name=id]').val(selected);
})
$('body').on('click','.build-hero__close', function (e) {
    e.preventDefault();
    $('.build-hero__inner').slideUp();
})